
import { Switch } from "@/components/ui/switch";
import { AiPrompt, PromptScope } from "@/services/supabase/ai-prompts";

interface PromptCardProps {
    prompt: AiPrompt;
    onEdit: () => void;
    onDelete: () => void;
    onToggleActive: (checked: boolean) => void;
}

export function PromptCard({
    prompt,
    onEdit,
    onToggleActive
}: PromptCardProps) {
    // Helper to get scope label
    const getScopeLabel = () => {
        switch (prompt.scope) {
            case PromptScope.Global: return "Global";
            case PromptScope.Project: return "Project";
            case PromptScope.Story: return "Story";
            case PromptScope.Chapter: return "Chapter";
            default: return "Unknown";
        }
    };

    return (
        <div
            onClick={onEdit}
            className="group flex items-center p-3 sm:p-4 gap-4 border border-border/40 rounded-2xl bg-card hover:bg-muted/30 hover:shadow-sm transition-all duration-200 cursor-pointer"
        >
            {/* 1. Content */}
            <div className="flex-1 min-w-0 flex flex-col justify-center gap-0.5">
                <div className="flex items-center gap-2">
                    <h4 className="text-base font-medium text-foreground leading-none">
                        {prompt.name}
                    </h4>
                    <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-medium text-muted-foreground border border-border/40 bg-transparent">
                        {getScopeLabel()}
                    </span>
                </div>

            </div>

            {/* 3. Controls (Grouped) */}
            <div className="flex items-center gap-1 sm:gap-3 flex-shrink-0 pl-2">
                <div onClick={(e) => e.stopPropagation()}>
                    <Switch
                        id={`active-${prompt.id}`}
                        checked={prompt.is_active}
                        onCheckedChange={onToggleActive}
                        className="data-[state=checked]:bg-green-600 dark:data-[state=checked]:bg-green-500 scale-90 sm:scale-100 transition-transform"
                    />
                </div>
            </div>
        </div>
    );
}
